import React from 'react'
import {Slice, Bar} from 'victory'

let withEvents = (DataComponent)=> ({datum, onClick, ...rest}) => (
  <DataComponent
    datum={datum}
    {...rest}

    events={{
      onClick: (e) => {
        onClick(datum)
      }
    }}
  />
)

let ClickableSlice = withEvents(Slice)
let ClickableBar = withEvents(Bar)

export {ClickableSlice, ClickableBar}


// WEBPACK FOOTER //
// ./src/etc/victory-utils.js